import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGnomeComponent } from './simple-icons-gnome.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGnomeComponent ],
    exports:      [ SimpleIconsGnomeComponent ],
    bootstrap:    []
})
export class SimpleIconsGnomeModule {}
